/* eslint-disable prettier/prettier */
const BASE_URL = process.env.REACT_APP_API_BASE_URL

export const API_URLS = {
    // Account
    LOGIN: `${BASE_URL}/api/Account/Login`,
    GET_SALT: `${BASE_URL}/api/Account/GetSalt`,
    DASHBOARD: `${BASE_URL}/api/Account/GetDashboard`,
    FORGET_PASSWORD: `${BASE_URL}/api/Account/ForgotPassword`,
    VERIFY_OTP: `${BASE_URL}/api/Account/VerifyOTP`,
    UPDATE_PASSWORD: `${BASE_URL}/api/Account/UpdatePassword`,
    CHANGE_PASSWORD: `${BASE_URL}/api/Account/ChangePassword`,
    REFRESH_TOKEN: `${BASE_URL}/api/Account/GetRefreshToken`,
    // Roles
    GET_ROLES: `${BASE_URL}/api/Role/GetRoles`,
    ADD_ROLE: `${BASE_URL}/api/Role/CreateRole`,
    UPDATE_ROLE: `${BASE_URL}/api/Role/UpdateRole`,
    DELETE_ROLE: `${BASE_URL}/api/Role/DeleteRole`,
    GET_ROLEBYID: `${BASE_URL}/api/Role/GetRole`,
    // Users
    GET_USERS: `${BASE_URL}/api/User/GetUsers`,
    ADD_USER: `${BASE_URL}/api/User/CreateUser`,
    UPDATE_USER: `${BASE_URL}/api/User/UpdateUser`,
    DELETE_USER: `${BASE_URL}/api/User/DeleteUser`,
    GET_USERBYID: `${BASE_URL}/api/User/GetUser`,
    // CMS -> AllPages
    ADD_CMS: `${BASE_URL}/api/CMSPages/ManageCMSPages`,
    GET_CMS: `${BASE_URL}/api/CMSPages/GetCMSPages`,
    // Awards
    GET_AWARDS: `${BASE_URL}/api/Award/GetAwards`,
    ADD_AWARD: `${BASE_URL}/api/Award/CreateAward`,
    GET_AWARD: `${BASE_URL}/api/Award/GetAward`,
    UPDATE_AWARD: `${BASE_URL}/api/Award/UpdateAward`,
    DELETE_AWARD: `${BASE_URL}/api/Award/DeleteAward`,
    // Donations
    GET_DONATIONS: `${BASE_URL}/api/Donations/GetDonations`,
    ADD_DONATION: `${BASE_URL}/api/Donations/CreateDonation`,
    GET_DONATION: `${BASE_URL}/api/Donations/GetDonation`,
    UPDATE_DONATION: `${BASE_URL}/api/Donations/UpdateDonation`,
    DELETE_DONATION: `${BASE_URL}/api/Donations/DeleteDonation`,
    // Gallery
    GET_GALLERIES: `${BASE_URL}/api/Gallery/GetGalleries`,
    ADD_GALLERY: `${BASE_URL}/api/Gallery/CreateGallery`,
    GET_GALLERY: `${BASE_URL}/api/Gallery/GetGallery`,
    UPDATE_GALLERY: `${BASE_URL}/api/Gallery/UpdateGallery`,
    DELETE_GALLERY: `${BASE_URL}/api/Gallery/DeleteGallery`,
    // HomeBanner
    GET_BANNERS: `${BASE_URL}/api/Banner/GetBanners`,
    ADD_BANNER: `${BASE_URL}/api/Banner/CreateBanner`,
    GET_BANNER: `${BASE_URL}/api/Banner/GetBanner`,
    UPDATE_BANNER: `${BASE_URL}/api/Banner/UpdateBanner`,
    DELETE_BANNER: `${BASE_URL}/api/Banner/DeleteBanner`,
    // KeyInitiatives
    GET_KEY_INITIATIVES: `${BASE_URL}/api/KeyInitiatives/GetKeyInitiatives`,
    ADD_KEY_INITIATIVE: `${BASE_URL}/api/KeyInitiatives/CreateKeyInitiative`,
    GET_KEY_INITIATIVE: `${BASE_URL}/api/KeyInitiatives/GetKeyInitiative`,
    UPDATE_KEY_INITIATIVE: `${BASE_URL}/api/KeyInitiatives/UpdateKeyInitiative`,
    DELETE_KEY_INITIATIVE: `${BASE_URL}/api/KeyInitiatives/DeleteKeyInitiative`,
    // Leaders
    GET_LEADERS: `${BASE_URL}/api/Leader/GetLeaders`,
    GET_LEADER_CATEGORIES: `${BASE_URL}/api/Leader/GetLeadersCategories`,
    GET_SORT_ORDER: `${BASE_URL}/api/Leader/GetLeaderSortOrder`,
    ADD_LEADER: `${BASE_URL}/api/Leader/CreateLeader`,
    GET_LEADER: `${BASE_URL}/api/Leader/GetLeader`,
    UPDATE_LEADER: `${BASE_URL}/api/Leader/UpdateLeader`,
    DELETE_LEADER: `${BASE_URL}/api/Leader/DeleteLeader`,
    // Offices
    GET_OFFICES: `${BASE_URL}/api/Office/GetOffices`,
    ADD_OFFICE: `${BASE_URL}/api/Office/CreateOffice`,
    GET_OFFICE: `${BASE_URL}/api/Office/GetOffice`,
    UPDATE_OFFICE: `${BASE_URL}/api/Office/UpdateOffice`,
    DELETE_OFFICE: `${BASE_URL}/api/Office/DeleteOffice`,
    // PageBanner
    GET_PAGE_BANNERS: `${BASE_URL}/api/PageBanner/GetPageBanners`,
    GET_WEB_PAGES: `${BASE_URL}/api/WebPages/GetWebPages`,
    ADD_PAGE_BANNER: `${BASE_URL}/api/PageBanner/CreatePageBanner`,
    GET_PAGE_BANNER: `${BASE_URL}/api/PageBanner/GetPageBanner`,
    UPDATE_PAGE_BANNER: `${BASE_URL}/api/PageBanner/UpdatePageBanner`,
    DELETE_PAGE_BANNER: `${BASE_URL}/api/PageBanner/DeletePageBanner`,
    // Insights -> Events
    GET_EVENTS: `${BASE_URL}/api/Insights/GetEvents`,
    ADD_EVENT: `${BASE_URL}/api/Insights/CreateEvent`,
    GET_EVENT: `${BASE_URL}/api/Insights/GetEvent`,
    UPDATE_EVENT: `${BASE_URL}/api/Insights/UpdateEvent`,
    DELETE_EVENT: `${BASE_URL}/api/Insights/DeleteEvent`,
    // Insights -> News
    GET_NEWS: `${BASE_URL}/api/Insights/GetNewsList`,
    ADD_NEWS: `${BASE_URL}/api/Insights/CreateNews`,
    GET_NEWS_BY_ID: `${BASE_URL}/api/Insights/GetNews`,
    UPDATE_NEWS: `${BASE_URL}/api/Insights/UpdateNews`,
    DELETE_NEWS: `${BASE_URL}/api/Insights/DeleteNews`,
    // Jobs
    GET_APPROVED_JOBS: `${BASE_URL}/api/Membership/GetApprovedMemberJobs`,
    GET_PENDING_JOBS: `${BASE_URL}/api/Membership/GetPendingMemberJobs`,
    GET_REJECTED_JOBS: `${BASE_URL}/api/Membership/GetRejectedMemberJobs`,
    DELETE_JOB: `${BASE_URL}/api/Membership/DeleteMemberJob`,
    APPROVE_JOB: `${BASE_URL}/api/Membership/ApproveMemberJob`,
    REJECT_JOB: `${BASE_URL}/api/Membership/RejectMemberJob`,
    GET_JOB: `${BASE_URL}/api/Membership/GetMemberJob`,
    // Country
    GET_COUNTRIES: `${BASE_URL}/api/Locations/GetCountries`,
    ADD_COUNTRY: `${BASE_URL}/api/Locations/CreateCountry`,
    GET_COUNTRY: `${BASE_URL}/api/Locations/GetCountry`,
    UPDATE_COUNTRY: `${BASE_URL}/api/Locations/UpdateCountry`,
    DELETE_COUNTRY: `${BASE_URL}/api/Locations/DeleteCountry`,
    // States
    GET_STATES: `${BASE_URL}/api/Locations/GetStates`,
    ADD_STATE: `${BASE_URL}/api/Locations/CreateState`,
    GET_STATE: `${BASE_URL}/api/Locations/GetState`,
    UPDATE_STATE: `${BASE_URL}/api/Locations/UpdateState`,
    DELETE_STATE: `${BASE_URL}/api/Locations/DeleteState`,
    // Cities
    GET_CITIES: `${BASE_URL}/api/Locations/GetCities`,
    ADD_CITY: `${BASE_URL}/api/Locations/CreateCity`,
    GET_CITY: `${BASE_URL}/api/Locations/GetCity`,
    UPDATE_CITY: `${BASE_URL}/api/Locations/UpdateCity`,
    DELETE_CITY: `${BASE_URL}/api/Locations/DeleteCity`,
    // Masters -> AnnualIncome
    GET_ANNUAL_INCOMES: `${BASE_URL}/api/Master/GetAnnualIncomes`,
    ADD_ANNUAL_INCOME: `${BASE_URL}/api/Master/CreateAnnualIncome`,
    GET_ANNUAL_INCOME: `${BASE_URL}/api/Master/GetAnnualIncome`,
    UPDATE_ANNUAL_INCOME: `${BASE_URL}/api/Master/UpdateAnnualIncome`,
    DELETE_ANNUAL_INCOME: `${BASE_URL}/api/Master/DeleteAnnualIncome`,
    // Masters -> BodyType
    GET_BODY_TYPES: `${BASE_URL}/api/Master/GetBodyTypes`,
    ADD_BODY_TYPE: `${BASE_URL}/api/Master/CreateBodyType`,
    GET_BODY_TYPE: `${BASE_URL}/api/Master/GetBodyType`,
    UPDATE_BODY_TYPE: `${BASE_URL}/api/Master/UpdateBodyType`,
    DELETE_BODY_TYPE: `${BASE_URL}/api/Master/DeleteBodyType`,
    // Masters -> Category
    GET_CATEGORIES: `${BASE_URL}/api/Master/GetCategories`,
    ADD_CATEGORY: `${BASE_URL}/api/Master/CreateCategory`,
    GET_CATEGORY: `${BASE_URL}/api/Master/GetCategory`,
    UPDATE_CATEGORY: `${BASE_URL}/api/Master/UpdateCategory`,
    DELETE_CATEGORY: `${BASE_URL}/api/Master/DeleteCategory`,
    // Masters -> Degree
    GET_DEGREES: `${BASE_URL}/api/Master/GetDegrees`,
    ADD_DEGREE: `${BASE_URL}/api/Master/CreateDegree`,
    GET_DEGREE: `${BASE_URL}/api/Master/GetDegree`,
    UPDATE_DEGREE: `${BASE_URL}/api/Master/UpdateDegree`,
    DELETE_DEGREE: `${BASE_URL}/api/Master/DeleteDegree`,
    // Masters -> DegreeGrade
    GET_DEGREE_GRADES: `${BASE_URL}/api/Master/GetDegreeGrades`,
    ADD_DEGREE_GRADE: `${BASE_URL}/api/Master/CreateDegreeGrade`,
    GET_DEGREE_GRADE: `${BASE_URL}/api/Master/GetDegreeGrade`,
    UPDATE_DEGREE_GRADE: `${BASE_URL}/api/Master/UpdateDegreeGrade`,
    DELETE_DEGREE_GRADE: `${BASE_URL}/api/Master/DeleteDegreeGrade`,
    // Masters -> Designation
    GET_DESIGNATIONS: `${BASE_URL}/api/Master/GetDesignations`,
    ADD_DESIGNATION: `${BASE_URL}/api/Master/CreateDesignation`,
    GET_DESIGNATION: `${BASE_URL}/api/Master/GetDesignation`,
    UPDATE_DESIGNATION: `${BASE_URL}/api/Master/UpdateDesignation`,
    DELETE_DESIGNATION: `${BASE_URL}/api/Master/DeleteDesignation`,
    // Masters -> EmploymentNature
    GET_EMPLOYMENT_NATURES: `${BASE_URL}/api/Master/GetEmploymentNatures`,
    ADD_EMPLOYMENT_NATURE: `${BASE_URL}/api/Master/CreateEmploymentNature`,
    GET_EMPLOYMENT_NATURE: `${BASE_URL}/api/Master/GetEmploymentNature`,
    UPDATE_EMPLOYMENT_NATURE: `${BASE_URL}/api/Master/UpdateEmploymentNature`,
    DELETE_EMPLOYMENT_NATURE: `${BASE_URL}/api/Master/DeleteEmploymentNature`,
    // Masters -> Gender
    GET_GENDERS: `${BASE_URL}/api/Master/GetGenders`,
    ADD_GENDER: `${BASE_URL}/api/Master/CreateGender`,
    GET_GENDER: `${BASE_URL}/api/Master/GetGender`,
    UPDATE_GENDER: `${BASE_URL}/api/Master/UpdateGender`,
    DELETE_GENDER: `${BASE_URL}/api/Master/DeleteGender`,
    // Masters -> maritalStatus
    GET_MARITAL_STATUSES: `${BASE_URL}/api/Master/GetMaritalStatuses`,
    ADD_MARITAL_STATUS: `${BASE_URL}/api/Master/CreateMaritalStatus`,
    GET_MARITAL_STATUS: `${BASE_URL}/api/Master/GetMaritalStatus`,
    UPDATE_MARITAL_STATUS: `${BASE_URL}/api/Master/UpdateMaritalStatus`,
    DELETE_MARITAL_STATUS: `${BASE_URL}/api/Master/DeleteMaritalStatus`,
    // Masters -> MotherTongue
    GET_MOTHER_TONGUES: `${BASE_URL}/api/Master/GetMotherTongues`,
    ADD_MOTHER_TONGUE: `${BASE_URL}/api/Master/CreateMotherTongue`,
    GET_MOTHER_TONGUE: `${BASE_URL}/api/Master/GetMotherTongue`,
    UPDATE_MOTHER_TONGUE: `${BASE_URL}/api/Master/UpdateMotherTongue`,
    DELETE_MOTHER_TONGUE: `${BASE_URL}/api/Master/DeleteMotherTongue`,
    // Masters -> Nationality
    GET_NATIONALITIES: `${BASE_URL}/api/Master/GetNationalities`,
    ADD_NATIONALITY: `${BASE_URL}/api/Master/CreateNationality`,
    GET_NATIONALITY: `${BASE_URL}/api/Master/GetNationality`,
    UPDATE_NATIONALITY: `${BASE_URL}/api/Master/UpdateNationality`,
    DELETE_NATIONALITY: `${BASE_URL}/api/Master/DeleteNationality`,
    // Masters -> Occupation
    GET_OCCUPATIONS: `${BASE_URL}/api/Master/GetOccupations`,
    ADD_OCCUPATION: `${BASE_URL}/api/Master/CreateOccupation`,
    GET_OCCUPATION: `${BASE_URL}/api/Master/GetOccupation`,
    UPDATE_OCCUPATION: `${BASE_URL}/api/Master/UpdateOccupation`,
    DELETE_OCCUPATION: `${BASE_URL}/api/Master/DeleteOccupation`,
    // Masters -> Relationship
    GET_RELATIONSHIPS: `${BASE_URL}/api/Master/GetRelationships`,
    ADD_RELATIONSHIP: `${BASE_URL}/api/Master/CreateRelationship`,
    GET_RELATIONSHIP: `${BASE_URL}/api/Master/GetRelationship`,
    UPDATE_RELATIONSHIP: `${BASE_URL}/api/Master/UpdateRelationship`,
    DELETE_RELATIONSHIP: `${BASE_URL}/api/Master/DeleteRelationship`,
    // Masters -> Religion
    GET_RELIGIONS: `${BASE_URL}/api/Master/GetReligions`,
    ADD_RELIGION: `${BASE_URL}/api/Master/CreateReligion`,
    GET_RELIGION: `${BASE_URL}/api/Master/GetReligion`,
    UPDATE_RELIGION: `${BASE_URL}/api/Master/UpdateReligion`,
    DELETE_RELIGION: `${BASE_URL}/api/Master/DeleteReligion`,
    // Masters -> Skincolors
    GET_SKIN_COLORS: `${BASE_URL}/api/Master/GetSkinColors`,
    ADD_SKIN_COLOR: `${BASE_URL}/api/Master/CreateSkinColor`,
    GET_SKIN_COLOR: `${BASE_URL}/api/Master/GetSkinColor`,
    UPDATE_SKIN_COLOR: `${BASE_URL}/api/Master/UpdateSkinColor`,
    DELETE_SKIN_COLOR: `${BASE_URL}/api/Master/DeleteSkinColor`,
    // Matrimonial
    GET_APPROVED_MATRIMONIAL: `${BASE_URL}/api/Membership/GetApprovedMemberMatrimonial`,
    GET_PENDING_MATRIMONIAL: `${BASE_URL}/api/Membership/GetPendingMemberMatrimonial`,
    GET_REJECTED_MATRIMONIAL: `${BASE_URL}/api/Membership/GetRejectedMemberMatrimonial`,
    DELETE_MATRIMONIAL: `${BASE_URL}/api/Membership/DeleteMemberMatrimonial`,
    APPROVE_MATRIMONIAL: `${BASE_URL}/api/Membership/ApproveMemberMatrimonial`,
    REJECT_MATRIMONIAL: `${BASE_URL}/api/Membership/RejectMemberMatrimonial`,
    VIEW_MATRIMONIAL_PROFILE: `${BASE_URL}/api/MemberFrontend/ViewMemberMatrimonialProfile`,
    // Membership
    GET_APPROVED_MEMBERS: `${BASE_URL}/api/Membership/GetApprovedMembers`,
    GET_PENDING_MEMBERS: `${BASE_URL}/api/Membership/GetPendingMembers`,
    GET_REJECTED_MEMBERS: `${BASE_URL}/api/Membership/GetRejectedMembers`,
    DELETE_MEMBER: `${BASE_URL}/api/Membership/DeleteMember`,
    APPROVE_MEMBER: `${BASE_URL}/api/Membership/ApproveMember`,
    REJECT_MEMBER: `${BASE_URL}/api/Membership/RejectMember`,
    VIEW_MEMBER_PROFILE: `${BASE_URL}/api/Membership/ViewMember`,
}
